<template>
  <div>
    <h1>Mapeos de Campos a Listados</h1>
    <button class="btn btn-success mb-3" @click="showForm = true">
      Agregar Mapeo
    </button>

    <!-- Formulario para crear un nuevo mapeo -->
    <div v-if="showForm" class="mb-4 border p-3">
      <Form
        :fields="fields"
        v-model="newMapping"
        submitLabel="Guardar"
        @save="handleSaveMapping"
        @input="onFormInput"
      />
      <button class="btn btn-secondary mt-2" @click="showForm = false">
        Cancelar
      </button>
    </div>

    <List :items="mappings" :columns="columns" />
    <div v-if="mappings.length">
      <h5 class="mt-4">Eliminar mapeo</h5>
      <ul>
        <li v-for="mapping in mappings" :key="mapping._id">
          {{ mapping.model }} - {{ mapping.field }} ({{ mapping.list?.name }})
          <button
            class="btn btn-danger btn-sm ml-2"
            @click="deleteMapping(mapping._id)"
          >
            Eliminar
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import List from "@/components/gotrading/common/List.vue";
import Form from "@/components/gotrading/common/Form.vue";
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "FieldListMappingsPage",
  components: { List, Form },
  data() {
    return {
      mappings: [],
      showForm: false,
      newMapping: {
        model: "",
        field: "",
        list: "",
      },
      lists: [],
      models: [],
      fieldsForModel: [],
      columns: [
        { key: "model", label: "Modelo" },
        { key: "field", label: "Campo" },
        { key: "list.name", label: "Listado" },
      ],
      fields: [
        { key: "model", label: "Modelo", type: "select", options: [] },
        { key: "field", label: "Campo", type: "select", options: [] },
        {
          key: "list",
          label: "Listado",
          type: "select",
          options: [],
        },
      ],
    };
  },
  async mounted() {
    await this.fetchModels();
    await this.fetchLists();
    await this.fetchMappings();
  },
  methods: {
    async fetchModels() {
      try {
        const response = await wencesApi.get(
          "/api/gotrading/model-definitions"
        );
        this.models = response.data;
        console.log("Modelos cargados:", this.models);
        this.fields.find((f) => f.key === "model").options = this.models.map(
          (m) => ({
            value: m.modelName,
            label: m.modelName.charAt(0).toUpperCase() + m.modelName.slice(1),
          })
        );
      } catch (error) {
        console.error("Error al obtener modelos:", error);
      }
    },
    async fetchFieldsForModel(model) {
      try {
        const modelDef = this.models.find((m) => m.modelName === model);
        this.fieldsForModel = modelDef
          ? modelDef.fields.filter((f) => f.type === "list")
          : [];
        console.log(
          "Campos tipo list para el modelo seleccionado:",
          this.fieldsForModel
        );
        this.fields.find((f) => f.key === "field").options =
          this.fieldsForModel.map((f) => ({
            value: f.key,
            label: f.key.charAt(0).toUpperCase() + f.key.slice(1),
          }));
      } catch (error) {
        this.fieldsForModel = [];
        this.fields.find((f) => f.key === "field").options = [];
      }
    },
    async fetchLists() {
      try {
        const response = await wencesApi.get("/api/gotrading/lists");
        this.lists = response.data;
        console.log("Listados cargados:", this.lists);
        this.fields.find((f) => f.key === "list").options = this.lists.map(
          (l) => ({
            value: l._id,
            label: l.name.charAt(0).toUpperCase() + l.name.slice(1),
          })
        );
      } catch (error) {
        console.error("Error al obtener listados:", error);
      }
    },
    async fetchMappings() {
      try {
        const response = await wencesApi.get(
          "/api/gotrading/field-list-mappings"
        );
        this.mappings = response.data;
      } catch (error) {
        console.error("Error al obtener mapeos:", error);
      }
    },
    async handleSaveMapping(mapping) {
      try {
        await wencesApi.post("/api/gotrading/field-list-mappings", mapping);
        this.showForm = false;
        this.newMapping = {
          model: "",
          field: "",
          list: "",
        };
        await this.fetchMappings();
      } catch (error) {
        console.error("Error al guardar mapeo:", error);
      }
    },
    async deleteMapping(id) {
      try {
        await wencesApi.delete(`/api/gotrading/field-list-mappings/${id}`);
        await this.fetchMappings();
      } catch (error) {
        console.error("Error al eliminar mapeo:", error);
      }
    },
    async onFormInput(val, prevVal) {
      // Solo si el modelo cambió realmente
      if (val.model && (!prevVal || val.model !== prevVal.model)) {
        await this.fetchFieldsForModel(val.model);
        this.newMapping.field = "";
      }
    },
  },
};
</script>
